// Webpack 4 cannot parse axios's fetch adapter (uses ES2020 nullish coalescing).
// This stub signals that the fetch adapter is unavailable, causing axios to fall back to XHR.
module.exports = {
    getFetch: function() { return null; }
};
